"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GUARANTEED_RATE_BLUEPRINT = exports.GUARANTEED_RATE_GRAY = exports.GUARANTEED_RATE_RAVENSWOOD_GRAY = exports.GUARANTEED_RATE_ARROW_RED = exports.SYNERGY_ONE_YELLOW_DARK = exports.SYNERGY_ONE_YELLOW_LIGHT = exports.SYNERGY_ONE_GRAY_LIGHT = exports.BACKGROUND_GREY = exports.LINE_GREY = exports.SPIN_GREY = exports.DISABLE_GREY = exports.BUBBLE_GREY = exports.RED = exports.BLACK = exports.HOMEPOINT_COOL_GREY = exports.HOMEPOINT_OFF_WHITE = exports.HOMEPOINT_NAVY = exports.HOMEPOINT_LIGHT_BLUE = exports.HOMEPOINT_TEAL = exports.HOMEPOINT_FOCUS = exports.HOMEPOINT_ACCENT_BLUE = exports.HOMEPOINT_ACTIVE_GREEN = exports.HOMEPOINT_GREEN = exports.HOMEPOINT_BLUE = exports.HOMEBRIDGE_YELLOW_LIGHT = exports.HOMEBRIDGE_YELLOW = exports.HOMEBRIDGE_BLUE_DARK = exports.HOMEBRIDGE_BLUE = exports.CALIBER_PASTEL_GREEN = exports.CALIBER_PASTEL_BLUE = exports.CALIBER_ACCENT_BLUE = exports.CALIBER_ACTIVE_GREEN = exports.CALIBER_FOREST_GREEN = exports.CALIBER_GREEN_NEW = exports.CALIBER_GREEN = exports.CALIBER_NAVY = exports.CALIBER_BLUE_NEW = exports.CALIBER_BLUE = exports.DARK_PURPLE = exports.LIGHT_TEXT_GREY = exports.LIGHT_BACKGROUD_GREY = exports.DARK_TEXT_GREY = exports.LIST_BLUE = exports.TEAL = exports.ACTIVE_MOODY_YELLOW = exports.MELLOW_YELLOW = exports.LIGHT_PURPLE = exports.LIGHT_BLURPLE = exports.MOODY_BLURPLE = exports.LIGHT_GREY = exports.MEDIUM_GREY = exports.DARK_GREY = exports.WHITE = exports.FOCUS_B = exports.FOCUS = exports.ERROR = exports.PURPLE_RAIN = exports.FIGURE_PURPLE = exports.YELLOW = exports.SEA = exports.BLACK_SOUL = exports.DARK_GREY_2 = exports.GREY_4 = exports.GREY_3 = exports.GREY_2 = exports.GREY_1 = exports.LIGHT_GREY_BORDER_2 = exports.PURPLE_DUSK = exports.LIGHT_GREY_TEXT = exports.LIGHT_GREY_RADIO_BORDER = exports.LIGHT_MEDIUM_BACKGROUND_GREY = exports.LIGHT_GREY_BORDER = exports.LIGHT_GREY_PURPLE = void 0;
// NEW COLORS
var LIGHT_GREY_PURPLE = '#E8ECF6';
exports.LIGHT_GREY_PURPLE = LIGHT_GREY_PURPLE;
var LIGHT_GREY_BORDER = '#F4F4F4';
exports.LIGHT_GREY_BORDER = LIGHT_GREY_BORDER;
var LIGHT_MEDIUM_BACKGROUND_GREY = '#F5F5F5'; // ever so slightly darker than LIGHT_BACKGROUD_GREY

exports.LIGHT_MEDIUM_BACKGROUND_GREY = LIGHT_MEDIUM_BACKGROUND_GREY;
var LIGHT_GREY_RADIO_BORDER = '#D2D2D2';
exports.LIGHT_GREY_RADIO_BORDER = LIGHT_GREY_RADIO_BORDER;
var LIGHT_GREY_TEXT = '#777777';
exports.LIGHT_GREY_TEXT = LIGHT_GREY_TEXT;
var PURPLE_DUSK = '#9586B7';
exports.PURPLE_DUSK = PURPLE_DUSK;
var LIGHT_GREY_BORDER_2 = '#E6E6E6';
exports.LIGHT_GREY_BORDER_2 = LIGHT_GREY_BORDER_2;
var GREY_1 = '#FAFBFD';
exports.GREY_1 = GREY_1;
var GREY_2 = '#E5E5E5';
exports.GREY_2 = GREY_2;
var GREY_3 = '#E4E5EB';
exports.GREY_3 = GREY_3;
var GREY_4 = '#797E92';
exports.GREY_4 = GREY_4;
var DARK_GREY_2 = '#4C5165';
exports.DARK_GREY_2 = DARK_GREY_2;
var BLACK_SOUL = '#2D2D2D';
exports.BLACK_SOUL = BLACK_SOUL;
var SEA = '#28CEA8';
exports.SEA = SEA;
var YELLOW = '#FEC82A';
exports.YELLOW = YELLOW;
var FIGURE_PURPLE = '#190050';
exports.FIGURE_PURPLE = FIGURE_PURPLE;
var PURPLE_RAIN = '#42368E';
exports.PURPLE_RAIN = PURPLE_RAIN;
var ERROR = '#E01B25';
exports.ERROR = ERROR;
var FOCUS = '#7B61FF'; // Use when the background-color is a dark purple (#42368E or #190050). Does not pass text color contrast requirements.

exports.FOCUS = FOCUS;
var FOCUS_B = '#5339D7'; // Main focus ring color. Passes text color contrast requirements.
// OLD COLORS

exports.FOCUS_B = FOCUS_B;
var WHITE = '#FFFFFF';
exports.WHITE = WHITE;
var DARK_GREY = '#2D2D2D';
exports.DARK_GREY = DARK_GREY;
var MEDIUM_GREY = '#4D4D4D';
exports.MEDIUM_GREY = MEDIUM_GREY;
var LIGHT_GREY = '#8D8D8D';
exports.LIGHT_GREY = LIGHT_GREY;
var MOODY_BLURPLE = '#190050';
exports.MOODY_BLURPLE = MOODY_BLURPLE;
var LIGHT_BLURPLE = '#F3F4F9';
exports.LIGHT_BLURPLE = LIGHT_BLURPLE;
var LIGHT_PURPLE = '#42368E';
exports.LIGHT_PURPLE = LIGHT_PURPLE;
var MELLOW_YELLOW = '#FEC82A';
exports.MELLOW_YELLOW = MELLOW_YELLOW;
var ACTIVE_MOODY_YELLOW = '#FEB62A';
exports.ACTIVE_MOODY_YELLOW = ACTIVE_MOODY_YELLOW;
var TEAL = '#28CEA8';
exports.TEAL = TEAL;
var LIST_BLUE = '#A1AEE5';
exports.LIST_BLUE = LIST_BLUE;
var DARK_TEXT_GREY = '#717171';
exports.DARK_TEXT_GREY = DARK_TEXT_GREY;
var LIGHT_BACKGROUD_GREY = '#FAFBFD';
exports.LIGHT_BACKGROUD_GREY = LIGHT_BACKGROUD_GREY;
var LIGHT_TEXT_GREY = '#888888';
exports.LIGHT_TEXT_GREY = LIGHT_TEXT_GREY;
var DARK_PURPLE = '#42368E'; // CALIBER THEME
// CALIBER_BLUE_NEW and CALIBER_GREEN_NEW are temporary variables since Design would like to keep the current CALIBER_BLUE and CALIBER_GREEN hex values the same until the redesign is complete.

exports.DARK_PURPLE = DARK_PURPLE;
var CALIBER_BLUE = '#385988';
exports.CALIBER_BLUE = CALIBER_BLUE;
var CALIBER_BLUE_NEW = '#377DA9';
exports.CALIBER_BLUE_NEW = CALIBER_BLUE_NEW;
var CALIBER_NAVY = '#3F5885';
exports.CALIBER_NAVY = CALIBER_NAVY;
var CALIBER_GREEN = '#84BD00';
exports.CALIBER_GREEN = CALIBER_GREEN;
var CALIBER_GREEN_NEW = '#628225';
exports.CALIBER_GREEN_NEW = CALIBER_GREEN_NEW;
var CALIBER_FOREST_GREEN = '#445A17';
exports.CALIBER_FOREST_GREEN = CALIBER_FOREST_GREEN;
var CALIBER_ACTIVE_GREEN = '#00843D';
exports.CALIBER_ACTIVE_GREEN = CALIBER_ACTIVE_GREEN;
var CALIBER_ACCENT_BLUE = '#00A3E0';
exports.CALIBER_ACCENT_BLUE = CALIBER_ACCENT_BLUE;
var CALIBER_PASTEL_BLUE = '#A3C6FB';
exports.CALIBER_PASTEL_BLUE = CALIBER_PASTEL_BLUE;
var CALIBER_PASTEL_GREEN = '#92C6AB'; // HOMEBRIDGE THEME

exports.CALIBER_PASTEL_GREEN = CALIBER_PASTEL_GREEN;
var HOMEBRIDGE_BLUE = '#20A2D8';
exports.HOMEBRIDGE_BLUE = HOMEBRIDGE_BLUE;
var HOMEBRIDGE_BLUE_DARK = '#1B8DBC';
exports.HOMEBRIDGE_BLUE_DARK = HOMEBRIDGE_BLUE_DARK;
var HOMEBRIDGE_YELLOW = '#F0983A';
exports.HOMEBRIDGE_YELLOW = HOMEBRIDGE_YELLOW;
var HOMEBRIDGE_YELLOW_LIGHT = '#F6C844'; // HOMEPOINT THEME

exports.HOMEBRIDGE_YELLOW_LIGHT = HOMEBRIDGE_YELLOW_LIGHT;
var HOMEPOINT_BLUE = '#003763';
exports.HOMEPOINT_BLUE = HOMEPOINT_BLUE;
var HOMEPOINT_GREEN = '#23D58C';
exports.HOMEPOINT_GREEN = HOMEPOINT_GREEN;
var HOMEPOINT_ACTIVE_GREEN = '#138047';
exports.HOMEPOINT_ACTIVE_GREEN = HOMEPOINT_ACTIVE_GREEN;
var HOMEPOINT_ACCENT_BLUE = '#00AAC6';
exports.HOMEPOINT_ACCENT_BLUE = HOMEPOINT_ACCENT_BLUE;
var HOMEPOINT_FOCUS = '#00A3E0';
exports.HOMEPOINT_FOCUS = HOMEPOINT_FOCUS;
var HOMEPOINT_TEAL = '#06AECB';
exports.HOMEPOINT_TEAL = HOMEPOINT_TEAL;
var HOMEPOINT_LIGHT_BLUE = '#0D9BD5';
exports.HOMEPOINT_LIGHT_BLUE = HOMEPOINT_LIGHT_BLUE;
var HOMEPOINT_NAVY = '#0C3258';
exports.HOMEPOINT_NAVY = HOMEPOINT_NAVY;
var HOMEPOINT_OFF_WHITE = '#F6F6F6';
exports.HOMEPOINT_OFF_WHITE = HOMEPOINT_OFF_WHITE;
var HOMEPOINT_COOL_GREY = '#D7E2E6'; // OLDER COLORS

exports.HOMEPOINT_COOL_GREY = HOMEPOINT_COOL_GREY;
var BLACK = '#000000';
exports.BLACK = BLACK;
var RED = '#FF0000';
exports.RED = RED;
var BUBBLE_GREY = '#D4D4D4';
exports.BUBBLE_GREY = BUBBLE_GREY;
var DISABLE_GREY = BUBBLE_GREY;
exports.DISABLE_GREY = DISABLE_GREY;
var SPIN_GREY = '#E3E3E3';
exports.SPIN_GREY = SPIN_GREY;
var LINE_GREY = '#E5E5E5';
exports.LINE_GREY = LINE_GREY;
var BACKGROUND_GREY = '#F7F7F7'; // SYNERGY ONE THEME

exports.BACKGROUND_GREY = BACKGROUND_GREY;
var SYNERGY_ONE_GRAY_LIGHT = '#777777';
exports.SYNERGY_ONE_GRAY_LIGHT = SYNERGY_ONE_GRAY_LIGHT;
var SYNERGY_ONE_YELLOW_LIGHT = '#F6C844';
exports.SYNERGY_ONE_YELLOW_LIGHT = SYNERGY_ONE_YELLOW_LIGHT;
var SYNERGY_ONE_YELLOW_DARK = '#DEB147'; // GUARANTEED RATE THEME

exports.SYNERGY_ONE_YELLOW_DARK = SYNERGY_ONE_YELLOW_DARK;
var GUARANTEED_RATE_ARROW_RED = '#CB333B';
exports.GUARANTEED_RATE_ARROW_RED = GUARANTEED_RATE_ARROW_RED;
var GUARANTEED_RATE_RAVENSWOOD_GRAY = '#25282A';
exports.GUARANTEED_RATE_RAVENSWOOD_GRAY = GUARANTEED_RATE_RAVENSWOOD_GRAY;
var GUARANTEED_RATE_GRAY = '#636363';
exports.GUARANTEED_RATE_GRAY = GUARANTEED_RATE_GRAY;
var GUARANTEED_RATE_BLUEPRINT = '#1785A9';
exports.GUARANTEED_RATE_BLUEPRINT = GUARANTEED_RATE_BLUEPRINT;